import { render, staticRenderFns } from "./ReservedForYou.html?vue&type=template&id=6621e980&scoped=true&"
import script from "./ReservedForYou.js?vue&type=script&lang=js&"
export * from "./ReservedForYou.js?vue&type=script&lang=js&"
import style0 from "./ReservedForYou.scss?vue&type=style&index=0&id=6621e980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6621e980",
  null
  
)

export default component.exports